import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

function VerifyPage() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState('loading'); // loading, success, error
    const [message, setMessage] = useState('인증 확인 중입니다...');

    useEffect(() => {
        const verifyEmail = async () => {
            const token = searchParams.get('token');

            if (!token) {
                setStatus('error');
                setMessage('유효하지 않은 접근입니다. 인증 토큰이 없습니다.');
                return;
            }

            try {
                const apiUrl = process.env.REACT_APP_API_URL || 'https://campus-life-production.up.railway.app';
                // 서버의 이메일 인증 확인 엔드포인트 호출
                const response = await fetch(`${apiUrl}/api/auth/verify?token=${token}`, {
                    method: 'GET',
                });

                const data = await response.json();

                if (response.ok) {
                    setStatus('success');
                    setMessage('이메일 인증이 성공적으로 완료되었습니다!');
                } else {
                    setStatus('error');
                    setMessage(data.message || '인증에 실패했습니다. 만료된 링크일 수 있습니다.');
                }
            } catch (error) {
                setStatus('error');
                setMessage('서버 연결 실패! 네트워크 상태를 확인해주세요.');
            }
        };

        verifyEmail();
    }, [searchParams]);

    return (
        <div style={containerStyle}>
            <div style={cardStyle}>
                {status === 'loading' && <div style={iconStyle}>⏳</div>}
                {status === 'success' && <div style={{...iconStyle, color: '#10B981'}}>✅</div>}
                {status === 'error' && <div style={{...iconStyle, color: '#EF4444'}}>❌</div>}

                <h2 style={titleStyle}>
                    {status === 'loading' ? '잠시만 기다려주세요' :
                        status === 'success' ? '인증 완료' : '인증 실패'}
                </h2>

                <p style={descStyle}>{message}</p>

                {status !== 'loading' && (
                    <button
                        style={mainBtn}
                        onClick={() => navigate('/')}
                    >
                        {status === 'success' ? '로그인하러 가기' : '홈으로 돌아가기'}
                    </button>
                )}
            </div>
        </div>
    );
}

// 스타일 (기존 RegisterPage와 통일감 유지)
const containerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundColor: '#F3F4F6',
    fontFamily: 'Pretendard, sans-serif',
    padding: '0 20px'
};

const cardStyle = {
    backgroundColor: '#fff',
    padding: '50px 30px',
    borderRadius: '24px',
    boxShadow: '0 10px 25px rgba(0,0,0,0.05)',
    textAlign: 'center',
    maxWidth: '400px',
    width: '100%'
};

const iconStyle = {
    fontSize: '50px',
    marginBottom: '20px'
};

const titleStyle = {
    fontSize: '24px',
    fontWeight: '800',
    marginBottom: '15px',
    color: '#111827'
};

const descStyle = {
    color: '#6B7280',
    marginBottom: '35px',
    fontSize: '16px',
    lineHeight: '1.5',
    wordBreak: 'keep-all'
};

const mainBtn = {
    width: '100%',
    padding: '16px',
    background: '#000',
    color: '#fff',
    border: 'none',
    borderRadius: '14px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'background 0.2s'
};

export default VerifyPage;